import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { filter, map, switchMap, withLatestFrom, } from 'rxjs/operators';
import {
  SaveLocalFilters,
  SaveLocalFiltersSuccess,
  LocalFiltersActionTypes
} from './local-filters.actions';
import { State } from '../state';
import { FiltersActionTypes, LoadFiltersSuccess } from '../filters/filters.actions';
import { getFilterParams } from '~app/modules/filters/store/filters/filter-params.selectors';
import { Action, select, Store } from '@ngrx/store';
import { ProductsListUrlService } from '~app/modules/generic/services/products-list-url.service';
import { Filters, LocalFilters } from '~app/modules/filters/models';
import { getLocalFilters } from '~app/modules/filters/store/local-filters/local-filters.selectors';
import { Observable, of } from 'rxjs';
import { Params } from '@angular/router';
import { FiltersStateUtil } from '~app/modules/filters/utils/filters-state.util';

@Injectable()
export class LocalFiltersEffects {
  private paramFilters$ = this.store.pipe(select(getFilterParams));
  private localFilters$ = this.store.pipe(select(getLocalFilters));

  @Effect()
  saveLocalFilters$: Observable<Action> = this.actions$.pipe(
    ofType(LocalFiltersActionTypes.SAVE_LOCAL_FILTERS),
    withLatestFrom(
      this.localFilters$,
      (action: SaveLocalFilters, localFilters) => ({
        serverFilters: action.payload.serverFilters,
        paramFilters: action.payload.paramFilters,
        localFilters,
      })
    ),
    switchMap(({ serverFilters, paramFilters, localFilters }) => {
      const filtersToSave = LocalFiltersEffects.updateLocalFilters(localFilters, serverFilters, paramFilters);
      return of(new SaveLocalFiltersSuccess({ filtersToSave }));
    })
  );

  @Effect()
  saveLocalFiltersByLoadFiltersSuccessAndParams$: Observable<Action> = this.actions$.pipe(
    ofType(FiltersActionTypes.LOAD_FILTERS_SUCCESS),
    withLatestFrom(this.paramFilters$),
    map(([ action, paramFilters ]: [LoadFiltersSuccess, Params])=> ({
      serverFilters: action.payload.filters,
      paramFilters,
    })),
    filter(({ serverFilters, paramFilters }) => paramFilters && this.productsListUrlService.isProductListPage()),
    switchMap(({ serverFilters, paramFilters }) => {
      return of(new SaveLocalFilters({ serverFilters, paramFilters }));
    })
  );

  private static updateLocalFilters(localFilters: LocalFilters, serverFilters: Filters,
                                    paramFilters: { [key: string]: any }): LocalFilters {
    const categoriesToBeSaved = FiltersStateUtil.isCategoriesSelected(paramFilters)
      ? FiltersStateUtil.getCategories(localFilters, serverFilters, paramFilters)
      : [];
    const attributesToBeSaved = FiltersStateUtil.isAttributesSelected(paramFilters)
      ? FiltersStateUtil.getAttributes(localFilters, serverFilters, paramFilters)
      : [];

    return {
      categories: categoriesToBeSaved,
      attributes: attributesToBeSaved,
    };
  }

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private productsListUrlService: ProductsListUrlService,
  ) {
  }
}
